module.exports = __webpack_public_path__ + "static/media/wuerchahushan_web.4328998f.png";